import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  compact?: boolean;
}

export default function NewsCard({ item, compact = false }: NewsCardProps) {
  if (compact) {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300"
      >
        <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 资讯配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-col justify-between py-0.5">
          <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <span className="text-xs text-foreground-500">{item.publishDate}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 资讯配图`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-auto flex items-center gap-2 pt-1 text-xs text-foreground-500">
          <i className="ri-time-line"></i>
          <span>{item.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}